<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-notazz p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Notazz
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://notazz.com/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o Notazz
          </a>
        </small>
      </div>
      <hr />
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <form-group
          :disabled="form.id != null"
          slim
          select
          id="product-select"
          label="Nome do produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <form-group
        label="Chave de integração logística (Opcional)"
        id="logistics-key"
        v-model="form.logistics_key"
        :errors="errors.logistics_key"
        placeholder="Digite a chave..."
      />
      <form-group
        is-switch
        id="is-split"
        v-model="form.is_split"
        label="Fazer divisão por valor"
      />
      <div v-if="form.is_split" class="my-3">
        <small class="text-secondary">
          Selecione a porcentagem da divisão
        </small>
        <b-form-input
          id="tax-range"
          :min="0"
          :max="100"
          type="range"
          v-model="form.nfe_tax"
        />
        <div class="d-flex justify-content-between small pb-3">
          <span>NFE: {{ form.nfe_tax }} %</span>
          <span>NFSE: {{ form.nfse_tax }} %</span>
        </div>
      </div>
      <form-group
        v-else
        slim
        select
        id="type-select"
        label="Tipo de nota"
        v-model="form.type"
        :errors="errors.type"
        placeholder="Selecionar tipo de nota..."
        :options="[
          { id: 'nfse', name: 'Nota fiscal de serviço' },
          { id: 'nfe_55', name: 'Nota fiscal de produto' }
        ]"
      />
      <form-group
        id="token"
        label="Token"
        v-model="form.token"
        placeholder="Digite o token da integração..."
        :errors="errors.token"
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "product_id",
          "token",
          "status",
          "description",
          "is_split",
          "nfe_tax",
          "nfse_tax",
          "logistics_key"
        ],
        { is_split: false, nfe_tax: 30, nfse_tax: 70, logistics_key: "" }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v,
          nfe_tax: parseInt(v.nfe_tax) || 0
        };
      }
    },
    "form.nfe_tax": function(v) {
      this.form.nfse_tax = 100 - v;
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        (this.form.is_split || this.form.type) &&
        this.validDocument
      );
    }
  },
  methods: {
    clear() {
      this.form = {
        is_split: false,
        nfe_tax: 30,
        nfse_tax: 70,
        logistics_key: ""
      };
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      let data = {
        ...this.form
      };
      if (!data.is_split) {
        delete data.nfe_tax;
        delete data.nfse_tax;
      } else {
        delete data.type;
      }
      if (!data.logistics_key) delete data.logistics_key;

      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(this.onSuccess)
        .catch(error => {
          const message = error.response.data?.message?.length
            ? error.response.data.message[0]
            : "Erro ao salvar integração";
          this.$message.error(message);
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-notazz {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
